const mathJaxConfig = {
    tex: {
        inlineMath: [['$', '$']],
        displayMath: [['$$', '$$']]
    }
};

export default mathJaxConfig;